<div class="personal-visit-list">
<sc-no-data-container fitHeight [hasData]="this.dataSource.data.length > 0" class="table-container">

  <table class="mat-table-selection" mat-table [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
    [matSortDirection]="sortDirection">
    <!-- Displays a "no data" row when no rows are available. Prevents the table from looking nasty-->
    <ng-container matColumnDef="noRecord">
      <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="hint">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.hint"></sc-dictionary-label>
      </th>
      <td mat-cell *matCellDef="let visit">
        <span [class]="visit.hintStyle"></span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.name"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.name}} </td>
    </ng-container>

    <ng-container matColumnDef="firstname">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.firstname"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.firstname}} </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.company"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.company}} </td>
    </ng-container>

    <ng-container matColumnDef="visitedPerson">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.visitedperson"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitedPersonString}} </td>
    </ng-container>

    <ng-container matColumnDef="reason">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.reason"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.reason}} </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.notes"></sc-dictionary-label>
      </th>
      <td mat-cell class="multiple-lines text-selection" *matCellDef="let visit"> {{visit.notes}} </td>
    </ng-container>

    <ng-container matColumnDef="numberPlate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.numberplate"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.numberPlate}} </td>
    </ng-container>

    <ng-container matColumnDef="start">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.start"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.start}} </td>
    </ng-container>

    <ng-container matColumnDef="registrationCode">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.registrationCode"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.registrationCode}} </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.role"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.role}} </td>
    </ng-container>

    <ng-container matColumnDef="expectedArrival">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.expectedArrival"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.expectedArrival}}</td>
    </ng-container>

    <ng-container matColumnDef="lastTerminalRegistrationDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.lastTerminalRegistrationDate"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastTerminalRegistrationDate}}</td>
    </ng-container>

    <ng-container matColumnDef="lastClientRegistrationDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.lastClientRegistrationDate"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.lastClientRegistrationDate}}</td>
    </ng-container>

    <ng-container matColumnDef="visitStatus">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.visitStatus"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit">
          <sc-dictionary-label dictionaryKey="tmc-visit.common.enum.visitStatus.{{visit.personalVisitStatus}}"></sc-dictionary-label>
      </td>
    </ng-container>

    <ng-container matColumnDef="internal">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.internal"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit">
          {{visit.internal === true ? this.translationService.translate('common.enum.boolean.yes') : this.translationService.translate('common.enum.boolean.no')}}
      </td>
    </ng-container>

    <ng-container matColumnDef="instructionsStatus">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.instructionsStatus"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit">
        <sc-dictionary-label dictionaryKey="tmc-visit.common.enum.instructionsStatus.{{visit.instructionsStatus}}"></sc-dictionary-label>
      </td>
    </ng-container>

    <ng-container matColumnDef="supplementaryEquipments">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.supplementaryEquipments"></sc-dictionary-label>
      </th>
      <td mat-cell class="multiple-lines text-selection" *matCellDef="let visit"> {{visit.supplementaryEquipments}} </td>
    </ng-container>

    <ng-container matColumnDef="invitationSentDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc-visit.entity.visit.invitationSentDate"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.invitationSentDate}}</td>
    </ng-container>
    
    <ng-container matColumnDef="visitEnd">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'visitEnd'|
        translate:['tmc-visit.entity.visit.visitEnd', translationService.language]}}</th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.visitEnd}}</td>
    </ng-container>

    <ng-container matColumnDef="filler">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> &nbsp; </th>
      <td mat-cell *matCellDef="let visit"> &nbsp; </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr mat-row *matRowDef="let visit; columns: columnsToDisplay" [ngClass]="getRowStyles(visit)"
      (click)="toggleSelection(visit)"></tr>

  </table>

</sc-no-data-container>

<sc-content-spacer vertical double></sc-content-spacer>
<div class="counts">
  angezeigt werden: {{dataSource.data.length}}/{{totalCount}}
</div>
</div>
